import { useMutation, useQueryClient } from "react-query";

import { Move } from "../../types";
import MoveService from "../../services/Move";

import { QUERY_KEY } from "./useListMoves";

function useCreateMove(onSuccess?: (move: Move) => void) {
  const queryClient = useQueryClient();

  return useMutation(MoveService.createMove, {
    onSuccess: (move) => {
      queryClient.invalidateQueries(QUERY_KEY);
      onSuccess?.(move);
    },
  });
}

export default useCreateMove;
